export const LANGUAGE_STRINGS = {
    MAX_DOWNLOAD: 'Date Range for Download cannot exceed {{MAX_DOWNLOAD}} Days'
}